// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"382":"a24efca1","421":"e2ea7d94","774":"3bf8152e","960":"cd26cb07"}[chunkId] + ".css";
};